<template>
  <div
    class="flex flex-col lg:grid lg:grid-cols-2 2xl:flex 2xl:flex-row gap-16 lg:gap-8"
  >
    <VideoCard v-for="video in videos" :video="video" />
  </div>
</template>

<script lang="ts" setup>
import type { Video } from '~/types/videos';
defineProps<{
  videos: Video[];
}>();
</script>
